<template>
  <div class="media-displayer-tabs">
     <div class="row mb-3">
      <div class="w-auto mx-auto ">
        <b-nav pills align="center" class="tab-gallery-navigation">
          <b-nav-item v-if="hasParentMedia" :active="activeTabIndex === -1" @click="setActiveTab(-1)">
            {{ gallery.name || 'Main Gallery' }}
          </b-nav-item>
          <b-nav-item v-for="(subGallery, index) in gallery.sub_gallery"
                      :key="index"
                      :active="activeTabIndex === index"
                      @click="setActiveTab(index)">
              {{ subGallery.name || `Gallery ${index + 1}` }}
          </b-nav-item>
        </b-nav>
      </div>
    </div>

    <!-- Active tab content -->
    <div class="tab-content">
      <component 
        :is="getDisplayTypeComponent(activeGallery)" 
        :gallery="activeGallery" 
        @openGallery="$emit('openGallery', $event)"
      />
    </div>
  </div>
</template>

<script>
import { GalleryDisplayType } from '../constants/galleryDisplayType'
import HorizontalGallery from '../displayType/Horizontal'
import VerticalGallery from '../displayType/Vertical'
import CompactThumbGallery from '../displayType/CompactThumb'
import CompactHorizontalGallery from '../displayType/CompactHorizontal'
import ReelGallery from '../displayType/Reel'
import ContainerGallery from '../displayType/Container'

export default {
  name: 'MediaDisplayerTabs',

  components: {
    HorizontalGallery,
    VerticalGallery,
    CompactThumbGallery,
    CompactHorizontalGallery,
    ReelGallery,
    ContainerGallery
  },

  props: {
    gallery: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      activeTabIndex: 0
    }
  },

  mounted() {
    if (this.hasParentMedia) {
      this.activeTabIndex = -1
    }
  },

  computed: {
    hasParentMedia() {
      return this.gallery && this.gallery.tabs && this.gallery.tabs.some(tab => tab.count > 0)
    },

    activeGallery() {
      if (this.activeTabIndex === -1) {
        return this.gallery
      }
      return this.gallery.sub_gallery && this.gallery.sub_gallery[this.activeTabIndex] 
        ? this.gallery.sub_gallery[this.activeTabIndex] 
        : null
    }
  },

  methods: {
    setActiveTab(index) {
      this.activeTabIndex = index
    },

    getDisplayTypeComponent(gallery) {
      if (!gallery || !gallery.display_type) {
        return 'VerticalGallery'
      }

      switch (gallery.display_type) {
        case GalleryDisplayType.HORIZONTAL.value:
          return 'HorizontalGallery'
        case GalleryDisplayType.VERTICAL.value:
          return 'VerticalGallery'
        case GalleryDisplayType.COMPACT_THUMB.value:
          return 'CompactThumbGallery'
        case GalleryDisplayType.COMPACT_HORIZONTAL.value:
          return 'CompactHorizontalGallery'
        case GalleryDisplayType.REEL.value:
          return 'ReelGallery'
        case GalleryDisplayType.CONTAINER.value:
          return 'ContainerGallery'
        default:
          return 'VerticalGallery'
      }
    }
  }
}
</script>

<style scoped>
.media-displayer-tabs {
  margin-bottom: 2rem;
}

.tab-nav {
  display: flex;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 1rem;
}

.tab-button {
  background: none;
  border: none;
  padding: 0.75rem 1.5rem;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.3s ease;
  font-weight: 500;
  color: #666;
}

.tab-button:hover {
  background-color: #f5f5f5;
  color: #333;
}

.tab-button.active {
  color: #007bff;
  border-bottom-color: #007bff;
  background-color: #f8f9fa;
}

.tab-content {
  min-height: 200px;
}
</style>